const time = () => ({
  id: 8,
  start: '09:00:00',
  stop: '20:00:00',
  status: 'TWENTY_FOUR_HOUR',
  dayOfWeek: 'MONDAY',
});

export default time;
